"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureSurplusForms = exports.globalConfig = exports.inputStatesEqual = exports.resetStatus = exports.inputState = exports.inputStateArray = exports.createFormState = exports.touchAllInputs = exports.FormError = void 0;
var s_array_1 = require("s-array");
var s_js_1 = require("s-js");
var FormError;
(function (FormError) {
    FormError[FormError["ValuesNotSame"] = 11] = "ValuesNotSame";
    FormError[FormError["ValidateFn"] = 10] = "ValidateFn";
    FormError[FormError["StrRegex"] = 7] = "StrRegex";
    FormError[FormError["EmailRegex"] = 6] = "EmailRegex";
    FormError[FormError["Required"] = 5] = "Required";
    FormError[FormError["MaxStrLen"] = 4] = "MaxStrLen";
    FormError[FormError["MaxNumberLen"] = 3] = "MaxNumberLen";
    FormError[FormError["MinNumberLen"] = 2] = "MinNumberLen";
    FormError[FormError["MinStrLen"] = 1] = "MinStrLen";
})(FormError = exports.FormError || (exports.FormError = {}));
function touchAllInputs(form) {
    s_js_1.default.freeze(function () {
        // TODO: Add array inputs support
        form.inputs.forEach(function (sig) {
            var curr = s_js_1.default.sample(sig);
            if ("isArrayInput" in curr) {
                s_js_1.default.sample(curr.value).forEach(function (sig) {
                    var it = s_js_1.default.sample(sig);
                    return sig(__assign(__assign({}, it), { isTouched: true, __v: it.__v + 1 }));
                });
            }
            curr.isTouched = true;
            curr.__v += 1;
            sig(curr);
        });
    });
}
exports.touchAllInputs = touchAllInputs;
/**
 *
 * @param initialState starting values to initialize state with
 * @param validateFns validation function for top level error checking.
 *          Good for ensuring password is the same on two fields.
 *          WARN: Don't update DataSignals on input fields (causes infinite update cycles)
 */
function createFormState(initialState, validateFns) {
    var _a = createInputSignals(initialState), inputs = _a[0], inputSignals = _a[1], arrayInputs = _a[2];
    var statusSignal = s_js_1.default.data({
        globalError: 0,
        isChanged: false,
        isSubmitted: false,
        isTouched: false,
        isValid: false,
        submissions: 0,
    });
    var formState = __assign(__assign({}, inputs), { status: statusSignal, inputs: inputSignals, arrayInputs: arrayInputs });
    updateOnSignal();
    return formState;
    function updateOnSignal() {
        var formGlobalStatusReducer = inputSignals.reduce(reduceInputStatus, [
            false,
            false,
            0,
        ]);
        s_js_1.default(function () {
            var _a = formGlobalStatusReducer(), isChanged = _a[0], isTouched = _a[1], error = _a[2];
            for (var _i = 0, validateFns_1 = validateFns; _i < validateFns_1.length; _i++) {
                var fn = validateFns_1[_i];
                error = fn(formState) || error;
            }
            var status = s_js_1.default.sample(statusSignal);
            status.isChanged = isChanged;
            status.isTouched = isTouched;
            status.globalError = error;
            status.isValid = isChanged && error === 0;
            formState.status(status);
        });
        var _loop_1 = function (sig) {
            var arrayStatusReducer = s_js_1.default.sample(sig).value.reduce(reduceInputStatus, [
                false,
                false,
                0,
            ]);
            s_js_1.default(function () {
                var _a = arrayStatusReducer(), isChanged = _a[0], isTouched = _a[1], error = _a[2];
                sig(__assign(__assign({}, s_js_1.default.sample(sig)), { isChanged: isChanged,
                    isTouched: isTouched,
                    error: error }));
            });
        };
        // array input fields
        for (var _i = 0, arrayInputs_1 = arrayInputs; _i < arrayInputs_1.length; _i++) {
            var sig = arrayInputs_1[_i];
            _loop_1(sig);
        }
        // for (const sig of arrayInputs) {
        //     S.on(sig, () => {
        //         updateStatus();
        //     }, undefined, true);
        //
        //     S.on(S.sample(sig).value, () => {
        //         // TODO: whenever the array vlaue change update is changed
        //         console.log("arrays have changed");
        //         uppdateParentStatus(S.sample(sig).value);
        //     });
        // }
    }
    /** Create DataSignal<InputState> with props that match the given input */
    function createInputSignals(input) {
        // No good type-safe way to handle the dynamic props. So 'any' everywhere
        var out = {};
        var inputSignals = [];
        var arrayInputs = [];
        var _loop_2 = function (k) {
            var v = input[k];
            if (Array.isArray(v)) {
                var arrayValues = v.map(function (it, i) {
                    var name = k + i;
                    return inputState(name, it);
                });
                var initInput = inputStateArray(k, arrayValues);
                var sig = s_js_1.default.data(initInput);
                arrayInputs.push(sig);
                out[k] = sig;
                inputSignals.push(sig);
            }
            else {
                var sig = s_js_1.default.data(inputState(k, v));
                out[k] = sig;
                inputSignals.push(sig);
            }
        };
        for (var _i = 0, _a = Object.keys(input); _i < _a.length; _i++) {
            var k = _a[_i];
            _loop_2(k);
        }
        return [out, s_array_1.default(inputSignals), arrayInputs];
    }
}
exports.createFormState = createFormState;
function reduceInputStatus(status, sig) {
    var it = sig();
    var isChanged = status[0] || it.isChanged;
    var isTouched = status[1] || it.isTouched;
    var error = status[2] || it.error;
    return [isChanged, isTouched, error];
}
function inputStateArray(name, initialValue) {
    // Replace null values with undefined (friendlier to work with)
    var value = initialValue === null ? undefined : initialValue;
    var isDisabled = false;
    return {
        __v: 0,
        name: name,
        isArrayInput: true,
        error: 0,
        isTouched: false,
        isChanged: false,
        isDisabled: isDisabled,
        value: s_array_1.default(value.map(function (it) { return s_js_1.default.data(it); })),
        startValue: value.map(function (it) { return it.value; }),
        startDisabled: isDisabled,
    };
}
exports.inputStateArray = inputStateArray;
function inputState(name, initialValue) {
    var _a;
    // Replace null values with undefined (friendlier to work with)
    var value = initialValue === null ? undefined : initialValue;
    var isDisabled = false;
    if (initialValue && typeof initialValue === "object" && "__disabled" in initialValue) {
        isDisabled = (_a = initialValue.__disabled) !== null && _a !== void 0 ? _a : false;
        value = initialValue.__value;
    }
    return {
        __v: 0,
        name: name,
        error: 0,
        isTouched: false,
        isChanged: false,
        isDisabled: isDisabled,
        value: value,
        startValue: value,
        startDisabled: isDisabled,
    };
}
exports.inputState = inputState;
function resetStatus(status) {
    status.isSubmitted = false;
    status.submissions = 0;
    status.globalError = 0;
    status.isValid = false;
    status.isChanged = false;
}
exports.resetStatus = resetStatus;
function inputStatesEqual(fields, cmp) {
    return function (formState) {
        if (fields.length < 2) {
            if (fields.length === 1) {
                console.warn("Unexpected number of signals to compare in equal() to ", formState[fields[0]].name);
            }
            if (fields.length === 0)
                console.warn("No signals to compare in equal() ");
            return 0;
        }
        var states = fields.map(function (it) { return s_js_1.default.sample(formState[it]); });
        if (cmp) {
            return states.every(function (it) { return cmp(it, states[0]); }) ? 0 : FormError.ValuesNotSame;
        }
        else {
            return states.every(function (it) { return it.value === states[0].value; }) ? 0 : FormError.ValuesNotSame;
        }
    };
}
exports.inputStatesEqual = inputStatesEqual;
exports.globalConfig = {
    debounceTime: 200,
};
function configureSurplusForms(config) {
    Object.assign(exports.globalConfig, config);
}
exports.configureSurplusForms = configureSurplusForms;
//# sourceMappingURL=form-state.js.map